import { styled, Typography } from '@mui/material'
import {
  ShowHowDoesThisWorkIcon,
  StopMessagesIcon,
} from '../Material/Modal/Icons'
import { HeadBoxModal } from '../Material/Modal/Modal'
import { MAX_ENQUIRY_RESPONSES } from '../../Constants'

interface ModalProps {
  open: boolean
  closeModal: () => void
  action?: () => void | Promise<void>
}

export const StopMessageModal = ({
  open,
  closeModal,
  action,
}: ModalProps): JSX.Element => {
  return (
    <HeadBoxModal
      title={'Would you like to stop receiving messages from new venues?'}
      image={<StopMessagesIcon />}
      action={action}
      open={open}
      closeModal={closeModal}
      actionText={'Stop receiving messages'}
      cancel={true}
      cancelText={'Cancel'}
    />
  )
}

export const ShowInformationModal = ({
  open,
  closeModal,
}: ModalProps): JSX.Element => {
  const StyledList = styled('ul')(({ theme }) => ({
    margin: 0,
    paddingInlineStart: '1rem',
    [theme.breakpoints.up('sm')]: {
      paddingInlineStart: '0.6rem',
    },
  }))
  const copy = [
    'You submitted this enquiry on HeadBox, which we shared with a suitable selection of our venues on your behalf. Venues that are interested in hosting your event will send you a message, which you can review on this page.',
    `You can receive up to ${MAX_ENQUIRY_RESPONSES} messages and we will email you once they come in. Those that are a great fit for your enquiry will appear higher on here.`,
    'Match with any venues you like the look of and we will send them your contact details. It’s not a commitment to book - just a conversation starter and they will contact you directly to discuss things further.',
    'Decline any venues that aren’t right this time to open up a space for a new venue to message.',
  ]

  const text = (
    <StyledList>
      {copy.map((line, i) => (
        <li key={i}>
          <Typography
            marginBottom={i < copy.length - 1 ? '1.5rem' : 0}
            variant='body1'
          >
            {line}
          </Typography>
        </li>
      ))}
    </StyledList>
  )

  return (
    <HeadBoxModal
      title={'How does this work?'}
      image={<ShowHowDoesThisWorkIcon />}
      open={open}
      closeModal={closeModal}
    >
      {text}
    </HeadBoxModal>
  )
}
